(ns dre.pages.admin.events
  (:require
    [day8.re-frame.tracing :refer-macros [fn-traced]]
    [dre.app.router :as-alias router]
    [re-frame.core :as rf]))


(rf/reg-event-fx
  ::init
  (fn-traced
    []
    {::router/redirect-to-handler :admin-feed}))

(rf/reg-sub
 ::current-page
 (fn [db]
   (get-in db [:pages :current])))
